export const SITE_URL = 'https://cassette.diy';

export const SITE_MOTTO = 'Producing with structure.';

export type SeoMeta = {
  title: string;
  description: string;
  /** Short social / link-preview line; defaults to {@link description}. */
  ogDescription?: string;
  path: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  noindex?: boolean;
};

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og/cassette-music.svg`;

export const MUSIC_SEO: Record<string, SeoMeta> = {
  landing: {
    title: 'Cassette — Ship Your Music Faster | Track & Release Workflow',
    description:
      'All-in-one music project workspace: organize demos, mixes, artwork, and promo. Collaborate with your band or producer. Files stay in your cloud (Drive, Dropbox, OneDrive, Yandex) or Cassette Cloud. Try anonymously. Free tier: 3 tracks.',
    ogDescription: SITE_MOTTO,
    path: '/',
    ogType: 'website',
  },
  help: {
    title: 'Help & FAQ — Cassette Music Workflow',
    description:
      'Answers about Cassette: music project management, Google Drive sync, collaboration, pricing, and getting started with your release workflow.',
    path: '/help',
  },
  docs: {
    title: 'Documentation — Cassette',
    description:
      'Guides for Cassette: MCP / AI access with Cursor and Claude, music release workflow, and product documentation.',
    path: '/docs',
  },
  docsMcp: {
    title: 'MCP Setup — Cassette AI Assistant Integration',
    description:
      'Connect Cursor or Claude Desktop to Cassette via @cassette.diy/mcp. Manage tracks, uploads, and collaboration with personal access tokens.',
    path: '/docs/mcp',
  },
  upgrade: {
    title: 'Pricing — Cassette Music Plans',
    description:
      'Simple pricing: Free Starter (3 tracks), Artist $5/month or $10 with Cassette Cloud (100 tracks), Studio $25/month or $50 with Cassette Cloud (unlimited). Cancel anytime.',
    path: '/upgrade',
  },
};

export function absoluteUrl(path: string): string {
  if (path.startsWith('http')) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
}
